export default __webpack_public_path__ + "static/media/notification.bfeae0a1.svg";